import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import { useEthers } from './useEthers';
import { Contract } from 'ethers';
/**
 * `useLookupAddress` is a hook that is used to retrieve the ENS (e.g. `name.eth`) or Rave Names (e.g. `name.ftm`) for a specific address.
 * @param address address to lookup
 * @param options additional options
 * @returns {} Object with the following:
  - `ens: string | null | undefined` - ENS or Rave name of the account or null if not found.
  - `isLoading: boolean` - indicates whether the lookup is in progress.
  - `error: Error | null` - error that occurred during the lookup or null if no error occurred.
 * @public
 * @example
 * const { account } = useEthers()
 * const { ens } = useLookupAddress(account)
 *
 * return (
 *   <p>Account: {ens ?? account}</p>
 * )
 */
export function useLookupAddress(address) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    rave = _ref.rave;
  var _useEthers = useEthers(),
    library = _useEthers.library;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    ens = _useState2[0],
    setENS = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  useEffect(function () {
    var mounted = true;
    void _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var raveContract, resolved, _resolved;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!library || !address)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            setIsLoading(true);
            if (!rave) {
              _context.next = 14;
              break;
            }
            raveContract = new Contract('0x14Ffd1Fa75491595c6FD22De8218738525892101', [{
              inputs: [{
                internalType: 'address',
                name: 'owner',
                type: 'address'
              }, {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256'
              }],
              name: 'getName',
              outputs: [{
                internalType: 'string',
                name: '',
                type: 'string'
              }],
              stateMutability: 'view',
              type: 'function'
            }], library); // this call will fail anyway if the chain isn't Fantom, so we don't need an extra chainId check
            _context.next = 8;
            return raveContract.getName(address, 0);
          case 8:
            resolved = _context.sent;
            if (mounted) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return");
          case 11:
            setENS(resolved);
            _context.next = 20;
            break;
          case 14:
            _context.next = 16;
            return library.lookupAddress(address);
          case 16:
            _resolved = _context.sent;
            if (mounted) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return");
          case 19:
            setENS(_resolved);
          case 20:
            _context.next = 27;
            break;
          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](2);
            if (mounted) {
              _context.next = 26;
              break;
            }
            return _context.abrupt("return");
          case 26:
            setError(_context.t0);
          case 27:
            _context.prev = 27;
            setIsLoading(false);
            return _context.finish(27);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 22, 27, 30]]);
    }))();
    return function () {
      mounted = false;
    };
  }, [address, library]);
  return {
    ens: ens,
    isLoading: isLoading,
    error: error
  };
}